import { useEffect } from "react";
import { initAmplitude } from "./initAmplitude";
import { setAmplitudeAccount } from "./setAmplitudeAccount";
import { setAmplitudeUser } from "./setAmplitudeUser";

interface UseAmplitudeProps {
  userId?: string;
  accountId?: string;
}

export const useAmplitude = ({ userId, accountId }: UseAmplitudeProps = {}) => {
  useEffect(() => {
    // Initialize Amplitude
    initAmplitude();

    // Set user ID if provided
    if (userId) {
      setAmplitudeUser(userId);
    }

    // Set account ID if provided
    if (accountId) {
      setAmplitudeAccount(accountId);
    }
  }, [userId, accountId]);

  return {
    setAmplitudeUser,
    setAmplitudeAccount,
  };
};
